import { ReactElement, useState } from "react";
import { RyeInput } from "./RyeInput";
import Mexp from "math-expression-evaluator";

const mexp = new Mexp();

// Extract the props type from RyeInput
type RyeInputProps = Parameters<typeof RyeInput>[0];

// Create our props by omitting the ones we want to override, then adding our custom ones
type RyeNumericalInputProps = Omit<RyeInputProps, "onChange" | "onEnter"> & {
  onFormulaChange?: (value: string) => void;
  onFormulaEnter?: (value: string) => void;
  onChange?: (value: number | null) => void;
  onEnter?: (value: number | null) => void;
};

export function RyeNumericalInput({
  onFormulaChange = () => {},
  onFormulaEnter = () => {},
  onChange = () => {},
  onEnter = () => {},
  ...ryeInputProps
}: RyeNumericalInputProps): ReactElement {
  const [isFormulaInvalid, setIsFormulaInvalid] = useState(
    parseInput(ryeInputProps.startingText ?? "") === "invalid_formula",
  );

  function parseInput(text: string): number | null | "invalid_formula" {
    if (text === "") {
      return null;
    }
    try {
      return mexp.eval(text);
    } catch {
      return "invalid_formula";
    }
  }

  function handleInputChange(
    text: string,
    onFormulaChangeCallback: (value: string) => void,
    onChangeCallback: (value: number | null) => void,
  ) {
    onFormulaChangeCallback(text);
    const value = parseInput(text);
    if (value === "invalid_formula") {
      setIsFormulaInvalid(true);
    } else {
      setIsFormulaInvalid(false);
      onChangeCallback(value);
    }
  }

  return (
    <RyeInput
      {...ryeInputProps}
      onChange={(text) => handleInputChange(text, onFormulaChange, onChange)}
      onEnter={(text) => handleInputChange(text, onFormulaEnter, onEnter)}
      error={isFormulaInvalid}
    />
  );
}
